import { Helmet } from "react-helmet-async";

const SITE_URL = "https://captainroca.lovable.app";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogType?: "website" | "article";
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Per-route SEO. Sets unique <title>, meta description, self-referencing canonical,
 * og:* tags, twitter:* tags and optional JSON-LD structured data.
 *
 * Keep title ≤60 chars and description 50–160 chars.
 */
export const SEO = ({ title, description, path, ogType = "website", jsonLd }: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {ldArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
